<template>
  <v-footer height="auto" class="justify-space-around flex-column text-center">
    <base-text smallerText>Copyright 2020 Virtual House Pro </base-text>
    <base-text smallerText>
      <router-link to="terms">Terms of Service</router-link>
    </base-text>
    <base-text smallerText>
      Developed by Broski.dev
    </base-text>
  </v-footer>
</template>

<script>
import BaseText from "@/components/base/Text";

export default {
  name: "CoreFooter",
  components: {
    BaseText
  }
};
</script>

<style scoped>
a {
  color: #000 !important;
}
</style>
